import { ConcreteEncodable } from "./ConcreteEncodable";

import { StrategyParameterImplEncoder } from "../../encoder/StrategyParameterImplEncoder";

import * as CubiqTS from "../../index";
import { StrategyParameter } from "../StrategyParameter";

export class StrategyParameterImpl extends ConcreteEncodable implements StrategyParameter {
  public static enType: string = "com.bcdfx.model.event.lifecycle.StrategyParameterImpl";

  /*FID=1*/
  public parameterName: string;
  /*FID=2*/
  public parameterType: number;
  /*FID=3*/
  public parameterValue: string;
  /*FID=4*/
  public regGrp: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = StrategyParameterImplEncoder.Instance;
    this.setEncodableType(StrategyParameterImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "StrategyParameterImpl[" +
      "parameterName=" +
      this.parameterName +
      "parameterType=" +
      this.parameterType +
      "parameterValue=" +
      this.parameterValue +
      "regGrp=" +
      this.regGrp +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
